/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import { pageApi } from '@/main/api/page.api';
import { userNotificationsTags } from '@/main/modules/app/apiTags';
import { EHttpMethod } from '@/main/modules/app/appConstants';
import { invalidateOnSuccess } from '@/main/utils/invalidateOnSuccess';

export const inquiriesApi = pageApi.injectEndpoints({
    endpoints: (builder) => ({
        sendInquiryListViewed: builder.mutation<void, void>({
            query: () => ({
                url: 'inquiry/list/viewed',
                method: EHttpMethod.PUT,
            }),
            invalidatesTags: (_result, error) =>
                invalidateOnSuccess(error, [userNotificationsTags.USER_NOTIFICATIONS_LIST]),
        }),
    }),
});

export const { useSendInquiryListViewedMutation } = inquiriesApi;
